module.exports = __webpack_public_path__ + "img/xbox_platform.69153d1b.svg";